import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  tid: number;
  image: string;
  welcomeText: string;
  subText: string;
  androidQrImage: string;
  iosQrImage: string;
  scan_description_en: string;
  meta_title_en: string;
  meta_desc_en: string;
  metadataImage: string;
  androidText: string;
  iosText: string;
  androidLink: string;
  iosLink: string;
  published: boolean;
  created?: string;
  changed?: string;
}

// edit api call
const fetchSubCategoriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-mobile-app-header/${id}`);
  return response.data[0];
};

const useSubCategoriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
